<template>
  <button class="order-card" type="button" @click="$emit('select', order)">
    <div class="order-top">
      <TokenLogo :src="tokenImage" :name="tokenName" :size="40" />
      <div class="order-head">
        <p class="order-name">{{ tokenName }}</p>
        <p class="order-date">{{ dateLabel }}</p>
      </div>
      <span class="status-badge" :style="{ color: statusColor, background: statusBg }">
        {{ statusLabel }}
      </span>
    </div>

    <div class="order-divider"></div>

    <div class="order-stats">
      <div class="order-stat">
        <span class="order-stat-label">Amount</span>
        <span class="order-stat-value">{{ amountLabel }}</span>
      </div>
      <div class="order-stat-divider"></div>
      <div class="order-stat">
        <span class="order-stat-label">Tokens</span>
        <span class="order-stat-value">{{ tokensLabel }}</span>
      </div>
    </div>

    <p class="order-foot">Tap to view or cancel order</p>
  </button>
</template>

<script>
import TokenLogo from "@/components/invest/TokenLogo.vue";
import * as inv from "@/utils/invest.js";

export default {
  name: "InvestOrderCard",
  components: { TokenLogo },
  props: {
    order: { type: Object, required: true },
  },
  emits: ["select"],
  computed: {
    token() {
      return this.order.token || {};
    },
    tokenName() {
      return this.token.name || this.token.symbol || "—";
    },
    tokenImage() {
      return this.token.image || "";
    },
    currency() {
      return this.token.currency || "NGN";
    },
    dateLabel() {
      return inv.formatDayMonthYear(this.order.createdAt);
    },
    statusLabel() {
      return inv.orderStatusLabel(this.order.status);
    },
    statusColor() {
      return inv.orderStatusColor(this.order.status);
    },
    statusBg() {
      const c = this.statusColor.replace("#", "");
      const r = parseInt(c.substring(0, 2), 16);
      const g = parseInt(c.substring(2, 4), 16);
      const b = parseInt(c.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, 0.1)`;
    },
    amountLabel() {
      return inv.money(inv.orderAmountValue(this.order), this.currency, 2);
    },
    tokensLabel() {
      return inv.shareCount(inv.orderTokens(this.order));
    },
  },
};
</script>

<style lang="scss" scoped>
.order-card {
  display: block;
  width: 100%;
  text-align: left;
  background: #ffffff;
  border: 1px solid #e8ecf4;
  border-radius: 8px;
  padding: 14px 16px;
  cursor: pointer;
}

.order-top {
  display: flex;
  align-items: center;
  gap: 12px;
}

.order-head {
  flex: 1;
  min-width: 0;
}

.order-name {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #001240;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.order-date {
  margin: 2px 0 0;
  font-size: 11px;
  color: #8791a7;
}

.status-badge {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
}

.order-divider {
  height: 1px;
  background: #e8ecf4;
  margin: 12px 0;
}

.order-stats {
  display: flex;
  align-items: stretch;
  gap: 16px;
}

.order-stat {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.order-stat-label {
  font-size: 11px;
  color: #8791a7;
}

.order-stat-value {
  font-size: 13px;
  font-weight: 500;
  color: #001240;
}

.order-stat-divider {
  width: 1px;
  background: #e8ecf4;
}

.order-foot {
  margin: 12px 0 0;
  font-size: 11px;
  color: #8791a7;
}
</style>
